module.exports = __webpack_public_path__ + "static/media/013-woman-3.21493c69.svg";